import { Button, DialogActions } from '@mui/material';
import {
  CloseDialogButton,
  Dialog,
  DialogContent,
  DialogContentWrapper,
  DialogTitle,
  InfoList
} from 'apps/wrapper/src/components/shared/dialog/dialog.styles';
import { formatPhoneNumber } from 'apps/wrapper/src/utils/formatter';
import { FC } from 'react';

export interface LocationSwitchEventData {
  locationId: number;
  locationName: string;
  patientPhone: string;
  patientName: string | undefined;
  extraData?: any;
}

export interface SwitchLocationDialogDialogProps {
  eventData: LocationSwitchEventData;
  message: string;
  onClose: () => void;
  onSwitchLocation: (data: LocationSwitchEventData) => Promise<void>;
}

export const SwitchLocationDialog: FC<SwitchLocationDialogDialogProps> = (props) => {
  const { eventData, message, onClose, onSwitchLocation } = props;

  return (
    <Dialog
      open={true}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: '650px',
          maxWidth: '90%'
        }
      }}
    >
      <DialogContentWrapper>
        <CloseDialogButton onClick={onClose} />
        <DialogContent sx={{ width: 'auto', minHeight: 'auto', padding: '30px 10px 20px 10px' }}>
          <DialogTitle sx={{ cursor: 'default' }}>{message}</DialogTitle>
          <InfoList>
            {eventData.patientName && (
              <li>
                <label>Patient:</label>
                {eventData.patientName}
              </li>
            )}
            {!eventData.patientName && (
              <li>
                <label>Phone:</label>
                {formatPhoneNumber(eventData.patientPhone)}
              </li>
            )}
            <li>
              <label>Location:</label> {eventData.locationName}
            </li>
          </InfoList>
          <DialogActions sx={{ padding: 0, marginTop: '35px' }}>
            <Button size="small" onClick={onClose} sx={{ marginRight: '10px' }} disableElevation>
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => onSwitchLocation(eventData)}
              disableElevation
            >
              SWITCH PATIENT'S LOCATION AND OPEN
            </Button>
          </DialogActions>
        </DialogContent>
      </DialogContentWrapper>
    </Dialog>
  );
};
